import { ApiGenericResponse } from "../ApiGenericResponse";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";

const ENDPOINT = "/Auth/forgotpassword/reset";

export class ResetPasswordCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: ResetPasswordReqData;

    constructor(username: string, token: string, newPassword: string) {
        super();
        this.payload = new ResetPasswordReqData(username, token, newPassword);
    }

    public async execute(): Promise<ApiGenericResponse> {
        var res = await this.executeCommand(this.payload);
        return new ApiGenericResponse(res);
    }
}

class ResetPasswordReqData {
    username: string;
    forgotPasswordToken: string;
    newPassword: string;

    constructor(username: string, token: string, newPassword: string) {
        this.username = username;
        this.forgotPasswordToken = token;
        this.newPassword = newPassword;
    }
}
